import React from 'react';
import { Link, useInRouterContext } from 'react-router-dom';

// In-app link that uses the router when there is one (keeps the page from reloading) and falls back
// to a plain anchor outside a Router (isolated component tests).
export default function AppLink({ to, children, ...rest }) {
    const inRouter = useInRouterContext();
    if (inRouter) return <Link to={to} {...rest}>{children}</Link>;
    return <a href={to} {...rest}>{children}</a>;
}
